import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Favorite} from '@models/favorite';
import {TrackingService} from '@services/tracking.service';
import {Router} from '@angular/router';
import {ImageService} from '@services/image.service';

@Component({
  selector: 'app-preview-popup',
  templateUrl: './preview-popup.component.html',
  styleUrls: ['./preview-popup.component.scss']
})
export class PreviewPopupComponent implements OnInit {

    favorite: Favorite
    url = '';

    constructor(
        public trackingService: TrackingService,
        public dialogRef: MatDialogRef<PreviewPopupComponent>,
        public router: Router,
        public imageService: ImageService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.favorite = this.data.favorite;
        this.favorite.ad.description = (this.favorite.ad.description || '').replace(/\\r\\n\\r/gm, '<br/>').replace(/\\n/gm, '<br/>').replace(/\\r/gm, '');
        this.url = this.data.url;
    }

    onNoClick() {
        this.dialogRef.close(false);
    }
    onYesClick() {
        this.dialogRef.close(true);
    }
}
